import { Box, Button } from '@mui/material';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { AvatarFromAws } from '../../../components/avatarFromAws/AvatarFromAws';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { routesNames } from '../../../utils/constants';
import { convertWeekdaysReverse, toHumanDate, transformTimeFormat } from '../../../utils/data';
import { convertedArrayReverse } from '../../../utils/methods';
import { useStyles } from './mainInfo.styles';
import { IProps } from './types';

export const MainInfo = (props: IProps): JSX.Element => {
  const opportunities = useAppSelector((state) => state.organizerReducer.opportunitiesById);
  const searchString = new URLSearchParams(window.location.search);
  const id = searchString.get('id');
  const classes = useStyles();
  const navigate = useNavigate();
  const { setOpen } = props;
  const convertedArray = convertedArrayReverse(opportunities.categories);

  const frequencyShow = useMemo(() => {
    if (opportunities?.frequency[0] === 'ONE_DAY') {
      return toHumanDate(opportunities.startDate, 'd MMM yyyy');
    }
    return convertWeekdaysReverse[opportunities?.frequency[0]];
  }, [opportunities]);

  return (
    <Box className={classes.mainInfo}>
      <AvatarFromAws className={classes.mainPic} photoKey={opportunities.pictureUrl} notPublic />
      <div className={classes.infoBlock}>
        <div className={classes.top}>
          <div className={classes.goalsBlock}>
            <h3 className={classes.mainInfoTitle}>{opportunities.name}</h3>
            <div className={classes.tabContent}>
              {convertedArray && convertedArray.map((item: string) => (
                <p className={classes.tab}>{item}</p>
              ))}
            </div>
          </div>
          <div className={classes.buttonBlock}>
            <Button
              className={classes.buttonCancel}
              onClick={(): void => setOpen((prev:boolean) => (!prev))}
            >Cancel opportunity
            </Button>
            <Button
              className={classes.buttonEdit}
              onClick={(): void => navigate(`${routesNames.editOpportunity}?id=${id}`)}
            >Edit opportunity
            </Button>
          </div>
        </div>
        <div className={classes.bottom}>
          <div className={classes.bottom1}>
            <div className={classes.info}>
              <h5>Date </h5>
              <p>{frequencyShow}</p>
            </div>
            <div className={classes.info}>
              <h5>Time </h5>
              <p>{`${transformTimeFormat(opportunities.startDate)} - ${transformTimeFormat(opportunities.endDate)}`}</p>
            </div>
            <div className={classes.info}>
              <h5>Address</h5>
              <p>
                <a
                  href={`https://www.google.com/maps/place/${opportunities.address}`}
                  className={classes.addressClick}
                >{opportunities.address}
                </a>
              </p>
            </div>
            <div className={classes.info}>
              <h5>Max volunteers </h5>
              <p>{opportunities.maximumVolunteers}</p>
            </div>
          </div>
          <div className={classes.bottom2}>
            <div className={classes.info}>
              <h5>Contact name</h5>
              <p>{opportunities.contactName}</p>
            </div>
            <div className={classes.info}>
              <h5>Email</h5>
              <p>
                {opportunities.contactEmail}
              </p>
            </div>
            <div className={classes.info}>
              <h5>Phone</h5>
              <p>{opportunities ? opportunities.contactPhone : 'not phone'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};
